import { useRef, useState, useEffect, useCallback } from "react";
import './DappUse.css';
import img1 from '../decentassets/img1.png';
import img2 from '../decentassets/img2.png';
import img3 from '../decentassets/img3.png';
import img4 from '../decentassets/img4.png';
import img5 from '../decentassets/img5.png';
import img6 from '../decentassets/img6.png';

const cases = [
  { img: img1, name: "Gaming & Play-to-Earn" },
  { img: img2, name: "DeFi Applications" },
  { img: img3, name: "NFT Marketplaces" },
  { img: img4, name: "Supply Chain Tracking" },
  { img: img5, name: "Identity Management" },
  { img: img6, name: "Web3 SaaS Platforms" },
];

function getVisibleCount(width) {
  if (width < 576)  return 1;
  if (width < 768)  return 2;
  if (width < 1200) return 3;
  if (width < 1500) return 4;
  return 5;
}

export default function DappUse() {
  const scrollRef  = useRef(null);
  const [activeIndex,  setActiveIndex]  = useState(0);
  const [isCarousel,   setIsCarousel]   = useState(false);
  const [visibleCount, setVisibleCount] = useState(4);
  const total = cases.length;

  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      setIsCarousel(w < 1800);
      setVisibleCount(getVisibleCount(w));
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  useEffect(() => {
    setActiveIndex(0);
    if (scrollRef.current) scrollRef.current.scrollLeft = 0;
  }, [visibleCount]);

  const getCardWidth = useCallback(() => {
    const el = scrollRef.current;
    if (!el) return 0;
    const card = el.querySelector(".dapp-card");
    if (!card) return 0;
    const gap = parseFloat(getComputedStyle(el).columnGap) || 20;
    return card.offsetWidth + gap;
  }, []);

  const scrollToIndex = useCallback((index) => {
    const maxIdx = total - visibleCount;
    const clamped = Math.max(0, Math.min(index, maxIdx));
    const el = scrollRef.current;
    if (!el) return;
    el.scrollTo({ left: clamped * getCardWidth(), behavior: "smooth" });
    setActiveIndex(clamped);
  }, [total, visibleCount, getCardWidth]);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el || !isCarousel) return;
    let timer;
    const onScroll = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        const maxIdx = total - visibleCount;
        const idx = Math.round(el.scrollLeft / getCardWidth());
        setActiveIndex(Math.max(0, Math.min(idx, maxIdx)));
      }, 80);
    };
    el.addEventListener("scroll", onScroll, { passive: true });
    return () => { el.removeEventListener("scroll", onScroll); clearTimeout(timer); };
  }, [isCarousel, visibleCount, total, getCardWidth]);

  const maxIndex = total - visibleCount;

  return (
    <section id="dapp-use" className="dappmainclass">
      <div className="dapp-top">
        <h2>Real-World Use Cases for dApp Development</h2>
        <p>
          Explore real-world dApp use cases delivering secure, scalable, and practical
          decentralized solutions across modern industries.
        </p>
      </div>

      <div className="dapp-slider">
        {isCarousel && (
          <button
            className="dapp-arrow dapp-arrow-left"
            onClick={() => scrollToIndex(activeIndex - 1)}
            disabled={activeIndex === 0}
            aria-label="Previous"
          >&#8249;</button>
        )}

        <div
          ref={scrollRef}
          className={`dapp-cards ${isCarousel ? "carousel" : "grid"}`}
          style={isCarousel ? { "--visible": visibleCount } : {}}
        >
          {cases.map((card, i) => (
            <div key={i} className="dapp-card">
              <img src={card.img} alt={card.name} />
              <span>{card.name}</span>
            </div>
          ))}
        </div>

        {isCarousel && (
          <button
            className="dapp-arrow dapp-arrow-right"
            onClick={() => scrollToIndex(activeIndex + 1)}
            disabled={activeIndex >= maxIndex}
            aria-label="Next"
          >&#8250;</button>
        )}
      </div>

      {isCarousel && (
        <div className="dapp-dots">
          {Array.from({ length: maxIndex + 1 }).map((_, i) => (
            <button
              key={i}
              className={`dot ${i === activeIndex ? "active" : ""}`}
              onClick={() => scrollToIndex(i)}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>
      )}
    </section>
  );
}